var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9548_2086)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 36.4C52 42.9296 46.946 48.3658 40.3333 49.4152V51.8C40.3333 53.0144 39.2903 54 38 54C36.7097 54 35.6667 53.0144 35.6667 51.8V49.4152C29.054 48.3658 24 42.9296 24 36.4C24 35.1856 25.043 34.2 26.3333 34.2C27.6237 34.2 28.6667 35.1856 28.6667 36.4C28.6667 41.2532 32.8527 45.2 38 45.2C43.1473 45.2 47.3333 41.2532 47.3333 36.4C47.3333 35.1856 48.3763 34.2 49.6667 34.2C50.957 34.2 52 35.1856 52 36.4ZM33.3333 36.4V25.4C33.3333 22.969 35.4217 21 38 21C40.5783 21 42.6667 22.969 42.6667 25.4V36.4C42.6667 38.831 40.5783 40.8 38 40.8C35.4217 40.8 33.3333 38.831 33.3333 36.4Z",
    fill: "#A2A2A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9548_2086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioChat);
export default __webpack_public_path__ + "static/media/audio-chat.df96e5fea0f9d58a92b01a768c3ed5ae.svg";
export { ForwardRef as ReactComponent };